document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.basic-pdp').forEach(function (root) {
    var thumbs = root.querySelectorAll('.basic-pdp__thumb');
    var mainImg = root.querySelector('.basic-pdp__main-image img');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        if (mainImg && thumb.dataset.full) {
          mainImg.src = thumb.dataset.full;
        }
      });
    });

    var qtyInput = root.querySelector('.basic-pdp__qty-input');
    var decBtn = root.querySelector('[data-qty="dec"]');
    var incBtn = root.querySelector('[data-qty="inc"]');

    if (decBtn && qtyInput) {
      decBtn.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = val;
      });
    }

    if (incBtn && qtyInput) {
      incBtn.addEventListener('click', function () {
        var val = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = val;
      });
    }
  });

  var stickyBars = document.querySelectorAll('.basic-pdp__sticky');
  if (stickyBars.length) {
    var onScroll = function () {
      var show = window.scrollY > 620;
      stickyBars.forEach(function (bar) {
        bar.classList.toggle('is-visible', show);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
});